import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useShopsContext } from '../../contexts/ShopsContext';
import './ConvocationModal.scss';

const CONVOCATION_BCJ2025 = 'BCJ2025';
const CONVOCATION_BCJ2026 = 'BCJ2026';
const CONVOCATION_NONE = 'NONE';

const OPTIONS = [CONVOCATION_BCJ2025, CONVOCATION_BCJ2026, CONVOCATION_NONE];

const OPTION_KEYS = {
  [CONVOCATION_BCJ2025]: 'bcj2025',
  [CONVOCATION_BCJ2026]: 'bcj2026',
  [CONVOCATION_NONE]: 'notBeneficiary',
};

const ConvocationModal = () => {
  const { t } = useTranslation();
  const { dismissModal } = useShopsContext();
  const [selected, setSelected] = useState(null);

  return (
    <div className="ConvocationModal">
      <div className="ConvocationModal__card">
        <div className="ConvocationModal__card__icon">?</div>
        <h2 className="ConvocationModal__card__title">
          {t('Shops.convocationModal.title')}
        </h2>
        <div className="ConvocationModal__card__options">
          {OPTIONS.map((option) => (
            <button
              key={option}
              type="button"
              className={`ConvocationModal__card__options__option ${selected === option ? 'selected' : ''}`}
              onClick={() => setSelected(option)}
            >
              <div className="ConvocationModal__card__options__option__radio" />
              <span>{t(`Shops.convocationModal.${OPTION_KEYS[option]}`)}</span>
            </button>
          ))}
        </div>
        <button
          type="button"
          className="ConvocationModal__card__continue"
          disabled={!selected}
          onClick={() => dismissModal(selected)}
        >
          {t('Shops.convocationModal.continue')}
        </button>
      </div>
    </div>
  );
};

export default ConvocationModal;
